import { useMutation, useQueryClient } from '@tanstack/react-query';

import { MERCHANDISING_COLLECTION_QUERY_KEY } from './useGetMerchandisingCollection';
import { MERCHANDISING_COLLECTIONS_QUERY_KEY } from './useGetMerchandisingCollections';
import { MERCHANDISING_COLLECTION_SLICE_QUERY_KEY } from './useGetMerchandisingCollectionSlice';
import { MERCHANDISING_COLLECTION_SLICES_QUERY_KEY } from './useGetMerchandisingCollectionSlices';

import MerchandisingCollectionsService from '@/services/MerchandisingCollectionsService';

export function useRemoveMerchandisingCollectionSlice() {
  const queryClient = useQueryClient();

  const { mutateAsync, isPending } = useMutation({
    mutationFn: ({
      collectionId,
      sliceId,
    }: {
      collectionId: number;
      sliceId: number;
    }) => MerchandisingCollectionsService.removeSlice(collectionId, sliceId),
    onSuccess: (_data, variables) => {
      const { collectionId, sliceId } = variables;

      queryClient.invalidateQueries({
        queryKey: MERCHANDISING_COLLECTIONS_QUERY_KEY,
      });

      queryClient.invalidateQueries({
        queryKey: [...MERCHANDISING_COLLECTION_QUERY_KEY, collectionId],
      });

      queryClient.invalidateQueries({
        queryKey: [...MERCHANDISING_COLLECTION_SLICES_QUERY_KEY, collectionId],
      });

      queryClient.invalidateQueries({
        queryKey: [
          ...MERCHANDISING_COLLECTION_SLICE_QUERY_KEY,
          collectionId,
          sliceId,
        ],
      });
    },
  });

  return {
    removeMerchandisingCollectionSlice: mutateAsync,
    isLoading: isPending,
  };
}
